/**
 * Invite-only mode restricts public registration:
 * - /signup redirects to /login
 * - Google/Microsoft users with no Firestore family are signed out with an invite message
 * - AccountCreationWizard requires an invite code unless this mode is off
 *
 * Build-time (CRA): `.env.production` locally or Firebase Hosting → Environment variables.
 * - **Default:** invite-only OFF (open signup / login paths for quick tests and staging-style prod).
 * - Set `REACT_APP_INVITE_ONLY=true` when you want production locked to invites only again.
 */
export function isInviteOnlyMode() {
  const raw = (process.env.REACT_APP_INVITE_ONLY ?? '').trim().toLowerCase();
  return raw === 'true' || raw === '1' || raw === 'yes';
}
